import React, { memo } from 'react';
import { useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { isAfter, addDays, format } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import { stateToTzMap } from '@ourbranch/state-to-tz-map';

import { useToast } from 'core/components/toast';
import Field from 'core/components/form/form.v2';
import DatePicker from 'core/components/date-picker';
import withDatePicker from 'core/components/with-date-picker';
import { CognitoPermissionGroups, PermissionRequireTypes } from 'core/helpers/cognito-permission-groups';
import useStyles from './segment-form.styles';

const SegmentForm = memo(({ onChange, startDate: from, minDate, maxDate, error, editingFirstSegment, policy }) => {
  const classes = useStyles();
  const { setFieldValue, values } = useFormikContext();
  const toast = useToast();

  //checks UW box if user does not have permission to do so if this is a renewal segment due to current UW backend rules
  const handleUWCheckbox = (from) => {
    onChange(from);
    const segmentStartDate = from.value;
    const endDate = utcToZonedTime(new Date(policy.endDate), stateToTzMap[policy.state]);
    if (isAfter(segmentStartDate, endDate)) {
      setFieldValue('underwritingChanges', true);
    } else {
      setFieldValue('underwritingChanges', false);
    }
  };

  const startDate = values.underwritingChanges ? addDays(maxDate, 1) : from;

  return (
    <Grid container alignItems="flex-end" className={classes.container}>
      <Grid item>
        <DatePicker
          name="startDate"
          onChange={handleUWCheckbox}
          value={startDate}
          error={error}
          helperText={error}
          mode="light"
          disabled={editingFirstSegment}
          disableFuture={false}
          label="Start date"
          className={classes.datePicker}
          minDate={minDate}
          maxDate={maxDate}
          fast={false}
        />
      </Grid>
      <Grid item>
        <Field
          type="checkbox"
          id="underwritingChanges"
          name="underwritingChanges"
          mode="light"
          label="Underwriting Changes for Renewal"
          fast={false}
          onChange={(event) => {
            if (event.target.checked) {
              toast.notify({
                type: 'success',
                message: `Updated start date for this change to ${format(addDays(maxDate, 1), 'MM/dd/yyyy')} since you selected underwriting changes for renewal.`
              });
            }
          }}
          permissions={{
            edit: {
              groups: [CognitoPermissionGroups.isTeamLeader],
              type: PermissionRequireTypes.AtLeastOne
            }
          }}
        />
      </Grid>
    </Grid>
  );
});

SegmentForm.propTypes = {
  onChange: PropTypes.func.isRequired,
  startDate: PropTypes.object.isRequired,
  minDate: PropTypes.object.isRequired,
  maxDate: PropTypes.object.isRequired,
  error: PropTypes.string
};

SegmentForm.defaultProps = {
  error: null
};

export default withDatePicker(SegmentForm);
